/**
 * Brings a step that has just appeared into view and puts the cursor in its
 * input — without the page jumping a second time.
 *
 * The contact form's code boxes open *below* the phone field, usually below
 * the fold on a desktop window and under the keyboard on a phone. Nothing
 * scrolled to them, so a visitor who tapped «send code» saw the number field
 * grey out and no place to type (production, 2026-10-15). The block is
 * centred first; the input is then focused with `preventScroll` so the
 * browser's own scroll-into-view cannot undo that.
 *
 * @param {{ scrollIntoView?: Function }|null|undefined} block The step's container.
 * @param {{ focus?: Function }|null|undefined} input The input to focus.
 */
export function revealStep(block, input) {
  // Immediate, not `smooth`: a smooth scroll is dropped when the layout moves under it (and where
  // motion is reduced), and this one has to land — the visitor is waiting for the boxes.
  block?.scrollIntoView?.({ block: 'center' })
  input?.focus?.({ preventScroll: true })
}
